package com.karyadina.cloudsync.model

import kotlinx.serialization.Serializable

/**
 * Metadata for cloud sync tracking
 * Used to detect conflicts and manage sync state
 */
@Serializable
data class StorageMetadata(
    val userId: String,
    val deviceId: String,
    val lastSyncTime: Long,
    val version: Int = 1,
    val checksum: String = "",
    val syncEnabled: Boolean = true
)

/**
 * Sync Status for UI display
 */
sealed class SyncStatus {
    object Idle : SyncStatus()
    object Syncing : SyncStatus()
    data class Success(val lastSyncTime: Long) : SyncStatus()
    data class Error(val message: String) : SyncStatus()
    object Disabled : SyncStatus()
}

/**
 * Background Sync Configuration
 */
@Serializable
data class BackgroundSyncConfig(
    val enabled: Boolean = false,
    val intervalMinutes: Int = 60, // 1 hour default
    val networkPreference: NetworkPreference = NetworkPreference.WIFI_ONLY,
    val lastScheduledTime: Long = 0L
)

enum class NetworkPreference {
    WIFI_ONLY,
    ALWAYS,
    ASK
}

/**
 * Pending Sync Item
 */
@Serializable
data class PendingSyncItem(
    val itemId: String,
    val itemType: String, // "note", "task", etc.
    val size: Long, // in bytes
    val timestamp: Long,
    val operation: SyncOperation
)

enum class SyncOperation {
    CREATE, UPDATE, DELETE
}

/**
 * Result of a sync operation
 */
@Serializable
data class SyncResult(
    val success: Boolean,
    val itemsSynced: Int,
    val failedItems: List<String> = emptyList(),
    val syncTime: Long, // milliseconds
    val errorMessage: String = ""
)

